// Local catalog — kept in sync with backend /api/products.

export const SOAPS = [
  {
    id: 'soap-lavender', name: 'Lavender Soap', price: 149,
    tagline: 'Calming florals · slow-cured purple bar',
    image: 'https://customer-assets.emergentagent.com/job_choco-wash-landing/artifacts/ttol47gm_image.png',
    placeholder: false, placeholderColor: '#CFBBE9', placeholderInk: '#3A2A66',
    category: 'soap', badge: 'Best Seller',
  },
  {
    id: 'soap-toy', name: 'Surprise Toy Soap', price: 161,
    tagline: 'A tiny toy tucked inside · bath time, made fun',
    image: 'https://customer-assets-jai6qajn.emergentagent.net/job_choco-wash-landing/artifacts/qha0nbxa_image.png',
    placeholder: false, placeholderColor: '#CDE8FF', placeholderInk: '#1E3350',
    category: 'soap', badge: 'New',
  },
  {
    id: 'soap-coffee', name: 'Chocolate Coffee Soap', price: 151,
    tagline: 'Cold-brew grounds & cocoa · morning exfoliation',
    image: 'https://customer-assets.emergentagent.com/job_choco-wash-landing/artifacts/f3ta2ilr_cccc.png',
    placeholder: false, placeholderColor: '#C8A484', placeholderInk: '#3E2614',
    category: 'soap', badge: null,
  },
  {
    id: 'soap-rose', name: 'Rose Milk Marble Soap', price: 139,
    tagline: 'Damask rose petals · marbled rose-milk swirl',
    image: 'https://customer-assets.emergentagent.com/job_choco-wash-landing/artifacts/8mhwhyxj_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2001_39_35%20PM.png',
    placeholder: false, placeholderColor: '#F6CDCB', placeholderInk: '#7A2A2A',
    category: 'soap', badge: null,
  },
  {
    id: 'soap-kids', name: 'Little Bubbles Kids', price: 149,
    tagline: 'Tear-free · milk & cocoa · pastel bar for tiny hands',
    image: 'https://customer-assets-jai6qajn.emergentagent.net/job_choco-wash-landing/artifacts/xrqyvgro_image.png',
    placeholder: false, placeholderColor: '#FFF0B8', placeholderInk: '#5A4200',
    category: 'soap', badge: 'Kids',
  },
  {
    id: 'soap-hamper', name: 'Luxury Soap Gift Hamper', price: 649,
    tagline: 'Pick any 4 soaps · linen gift box, hand-tied ribbon',
    image: null,
    placeholder: false,
    category: 'soap-bundle', badge: 'Customise',
    customizable: true,
    chooseCount: 4,
    choicesFrom: ['soap-lavender', 'soap-toy', 'soap-coffee', 'soap-rose', 'soap-kids'],
    contains: ['soap-lavender', 'soap-toy', 'soap-coffee', 'soap-rose'],
  },
];

export const CHOCOLATES = [
  {
    id: 'choc-milk', name: 'Milk Chocolate', price: 89,
    tagline: 'Creamy single-origin milk · slow conched',
    image: 'https://customer-assets.emergentagent.com/job_choco-wash-landing/artifacts/5hx8qsre_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2002_25_56%20PM.png',
    placeholderColor: '#C8A484', placeholderInk: '#3E2614',
    category: 'chocolate', badge: 'Best Seller',
  },
  {
    id: 'choc-dark', name: 'Dark Chocolate', price: 89,
    tagline: '70% cacao · earthy, slow-melt finish',
    image: 'https://customer-assets.emergentagent.com/job_choco-wash-landing/artifacts/bko63gxh_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2002_25_36%20PM.png',
    placeholderColor: '#6E4327', placeholderInk: '#F5E9DC',
    category: 'chocolate', badge: null,
  },
  {
    id: 'choc-almond', name: 'Almond Delight', price: 110,
    tagline: 'Roasted almonds · folded into milk chocolate',
    image: 'https://customer-assets.emergentagent.com/job_choco-wash-landing/artifacts/ibop4byw_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2002_30_05%20PM.png',
    placeholderColor: '#B58964', placeholderInk: '#3E2614',
    category: 'chocolate', badge: 'New',
  },
  {
    id: 'choc-fruit-nut', name: 'Fruit & Nut', price: 110,
    tagline: 'Hazelnut, almond, raisin, cranberry · every bite',
    image: 'https://customer-assets.emergentagent.com/job_choco-wash-landing/artifacts/b6varrok_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2002_25_21%20PM.png',
    placeholderColor: '#A87650', placeholderInk: '#3E2614',
    category: 'chocolate', badge: null,
  },
  {
    id: 'choc-white', name: 'White Chocolate', price: 89,
    tagline: 'Madagascar vanilla · velvet white bar',
    image: 'https://customer-assets.emergentagent.com/job_choco-wash-landing/artifacts/zsjx0o0u_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2002_25_00%20PM.png',
    placeholderColor: '#F1E2C8', placeholderInk: '#3E2614',
    category: 'chocolate', badge: null,
  },
  {
    id: 'choc-family', name: 'Chocolate Family Pack', price: 350,
    tagline: '4 classic bars · share-ready',
    image: 'https://images.pexels.com/photos/10303625/pexels-photo-10303625.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    placeholder: false,
    category: 'chocolate-bundle', badge: 'Family',
    contains: ['choc-milk', 'choc-dark', 'choc-almond', 'choc-fruit-nut'],
  },
  {
    id: 'choc-hamper', name: 'Artisan Chocolate Gift Hamper', price: 550,
    tagline: 'All 5 bars · wrapped wooden crate, hand-tied',
    image: 'https://static.prod-images.emergentagent.com/jobs/9712a3fc-5d12-4e06-9c2b-c166b1620ae7/images/555a8a6bdceca4c36adb104c6679ce04a5c9d8950b7e3842f85470d834172039.png',
    placeholder: false,
    category: 'chocolate-bundle', badge: 'Gift',
    contains: ['choc-milk', 'choc-dark', 'choc-almond', 'choc-fruit-nut', 'choc-white'],
  },
];

export const HERO_IMAGE = 'https://static.prod-images.emergentagent.com/jobs/9712a3fc-5d12-4e06-9c2b-c166b1620ae7/images/a750c5ef1f9f6908a00c4eea06110cfe3d6f3a4e221665b73a164caa8d4e380a.png';

export const ABOUT_IMAGE = 'https://images.pexels.com/photos/7543116/pexels-photo-7543116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

export const getProductById = (id) =>
  SOAPS.find((s) => s.id === id) || CHOCOLATES.find((c) => c.id === id);
